module.exports = __webpack_public_path__ + "static/media/nrna1.db052f87.png";